import { InvestingType } from "./kyc.data.models";

export interface UserPhone {
    phoneNumber?: string | undefined;
    userId?: string | undefined;
    nationalId?: string | undefined;
    purpose?: string | number | undefined;
    investTypeId?: InvestingType | number | string;
}
export enum GrpcLanguage {
    Ar = "Ar",
    En = "En",
}
export enum ERiskLevel
{
    Low = 'Low',
    Medium = 'Medium',
    MediumToHigh = 'MediumToHigh',
    High = 'High'
}
export interface LoginInvestorInputDto {
    phoneNumber: string;
    password: string;
    deviceType: MobileDeviceType;
    fcmToken: string | undefined;
    deviceId: string | undefined;
    otp: string;
    investTypeId: InvestingType | number;
}
export interface ValidateCredantialsDto {
    nationalId: string;
    password: string;
    investTypeId?: InvestingType | number;
}

export enum MobileDeviceType {
    Android = "Android",
    IOS = "IOS",
}

export interface UserPassword {
    password?: string | undefined;
    confirmPassword?: string | undefined;
    phoneNumber?: string | undefined;
    otp?: string | undefined;
    investTypeId?: InvestingType | number;
}

export interface UserRegisterInput {
    phoneNumber?: string | undefined;
    email?: string | undefined;
    nationalId?: string | undefined;
    nationalID?: string | undefined;
    birthDate?: string | undefined;
    language?: GrpcLanguage;
    investTypeId: InvestingType | number;
    gender?: number;
    isAcceptTerms?: boolean;
    fcmToken?: string;
    deviceId?: string;
    dateType?: 'hijri' | 'gregorian';
    crNumber?: string | undefined;
}

export interface VerifyYakeenUserInputDto {
    nationalId: string;
    investTypeId: InvestingType | number;
}

export interface UpdateIdExpirationDateInputDto {
    nationalId: string;
    otp: string;
    transactionId: string;
    investTypeId: InvestingType | number;
}

export interface RefreshTokenInputDto {
    phoneNumber?: string | undefined;
    refreshToken?: string | undefined;
}

export interface UserOTP {
    otp?: string | undefined;
    phoneNumber?: string | undefined;
    language?: GrpcLanguage;
    investTypeId?: InvestingType | number;
}
export enum DelegateRole {
    Primary = 1,
    ReadOnly = 2,
}

export enum DelegateStatus {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
}

export interface LoginResultDto {
    "currentUsedInvestorAccountId": string,
    "email": string,
    "phoneNumber": string,
    "nationalId": string,
    "userTypeId": string,
    "investTypeId": InvestingType,
    "userId": string,
    "token": string,
    "arabicName": string,
    "englishName": string,
    "isActivated": boolean,
    "isSuspended": boolean,
    "isIdExpired": boolean,
    "birthDate": Date,
    "gender": string,
    isCompleteProfile: boolean,
    userKYCStatus: string,
    "refreshToken": string,
    "expiryTokenInMinutes": number,
    "moznUserStatus": string,
    "investorDegreeType": string,
    "hasProfessionalPendingRequest": boolean,
    "hasInstitutionalPendingRequest": boolean,
    "expiryTokenDate": Date,
    "parentUserId": string,
    "currentActiveAccountId": string,
    kycRiskLevel: ERiskLevel,
    delegateRole?: DelegateRole | string,
    delegateStatus?: DelegateStatus | string,
    DelegateRole?: DelegateRole | string,
    DelegateStatus?: DelegateStatus | string
}